import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageStringObjectSelectionComponent } from './language-string-object-selection.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [LanguageStringObjectSelectionComponent],
  exports: [LanguageStringObjectSelectionComponent],
})
export class LanguageStringObjectSelectionModule {
}
